import React from 'react';
import styled from '@emotion/styled';
import { Space, SpaceProps } from 'antd';

export const RootContainer = styled.div`
  // padding: 24px;
  padding: 24px 0px;
  width: 100%;
  margin: 0 auto;
`;

export const CardMenuItem = styled.div`
  box-shadow: 0px 2px 4px 0px #00000040;
  min-height: 80px;
  margin-bottom: 24px;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  border-left: 4px solid #196eff;
  padding-left: 14px;
  padding-right: 10px;
  background: #fff;
  > div {
    padding-top: 33px;
    padding-bottom: 33px;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    > div {
      &:first-of-type {
        color: #000000;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.03em;
        text-align: left;
      }
      > .ant-tag {
        background: transparent;
        font-size: 10px;
        font-weight: 400;
        text-align: right;
      }
    }
  }
`;

export const Paper = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 4px 1px rgba(165, 178, 200, 0.1),
    0px 1px 6px rgba(165, 178, 200, 0.2);
  border-radius: 4px;
  padding: 40px;
  flex-direction: column;
  display: flex;
`;

const StyledWrapperInfoLine = styled(Space)`
  width: 100%;
  label {
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    color: #232b3a;
    text-transform: capitalize;
  }
  > div:last-of-type {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #232b3a;
  }
`;
export const InfoLine: React.FC<
  Partial<
    {
      label: string;
      value: React.ReactNode;
      ref?: any;
      // eslint-disable-next-line react/display-name
    } & SpaceProps
  >
  // eslint-disable-next-line react/display-name
> = React.forwardRef((props, ref: any) => {
  const { value, label, className, ...rest } = props;
  return (
    <div ref={ref as any} className={className}>
      <StyledWrapperInfoLine align="center" {...rest}>
        <label>{label}</label>
        {React.isValidElement(value) ? value : <span>{value}</span>}
      </StyledWrapperInfoLine>
    </div>
  );
});

const StatusLabel: React.FC<{
  status: 'passed' | 'rejected' | 'pending' | 'default' | 'failed' | 'report-as-is' | 'not-applicable';
  renderLabel?: () => React.ReactNode;
  className?: any;
}> = (props) => {
  const Labels = {
    passed: 'Passed',
    rejected: 'Reject',
    pending: 'Pending',
    failed: 'Failed',
    default: '',
    pass: 'Passed',
    'report-as-is': 'Report As Is',
    'not-applicable': 'Not Applicable',
    fail: 'Failed'
  };
  return (
    <p className={props.className}>
      {props.renderLabel ? props.renderLabel() : Labels[props.status]}
    </p>
  );
};

export const Status = styled(StatusLabel)`
  margin-bottom: -1px;
  font-size: 12px;
  color: ${(props) => {
    const Colors: any = {
      pending: '#8991A0',
      rejected: '#ED4646',
      failed: '#ED4646',
      passed: '#1EC000',
      pass: '#1EC000',
      fail: '#ED4646',
      'report-as-is': '#4E5A71',
      'not-applicable': '#4E5A71',
      default: ''
    };
    return Colors[props.status as any] as any;
  }};
`;

export const TitleField = styled.h5`
  font-size: 12px;
  font-weight: 700;
`;
